import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");

// Pages
const Login = () => import("@/views/Auth/Login");
const SignUp = () => import("@/views/Auth/SignUp");
const ResetPass = () => import("@/views/Auth/ResetPassword");
const AddPie = () => import("@/views/AddPie");
const Home = () => import("@/views/Home");
const PieId = () => import("@/views/PieId");
const PieIdForAdmin = () => import("@/views/PieIdForAdmin");
const Dashboard = () => import("@/views/Dashboard");
const AccountSettings = () => import("@/views/AccountSettings");
const BugReport = () => import("@/views/BugReport");
const Analytics = () => import("@/views/Reports/Analytics");
const lumpSum = () => import("@/views/Reports/LumpSum");
const WellLog = () => import("@/views/Reports/WellLog");

// Admin
const AdminDashboard = () => import("@/views/Admin/Dashboard");
const Users = () => import("@/views/Admin/Users");
const Pies = () => import("@/views/Admin/Pies");
const Purchases = () => import("@/views/Admin/Purchases");

// Products
const Products = () => import("@/views/Products");
// Services
const Services = () => import("@/views/Services");
// reports PAGES
const Contributions = () => import("@/views/Reports/Contributions");
const ContributionsSearch = () => import("@/views/Reports/ContributionsSearch");
const Summary = () => import("@/views/Reports/Summary");

// Shared Pages
const Page404 = () => import("@/views/Page404");
const ChangeLog = () => import("@/views/ChangeLog");

export default new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      redirect: "/login",
      name: "خانه",
      component: DefaultContainer,
      children: [
        {
          path: "/dashboard",
          name: "Dashboard",
          component: Dashboard,
        },
        {
          path: "/adminDashboard",
          name: "AdminDashboard",
          component: AdminDashboard,
        },
        {
          path: "/users",
          name: "Users",
          component: Users,
        },
        {
          path: "/pies",
          name: "Pies",
          component: Pies,
        },
        {
          path: "/products",
          name: "Products",
          component: Products,
        },
        {
          path: "/services",
          name: "Services",
          component: Services,
        },
        {
          path: "/purchases",
          name: "Purchases",
          component: Purchases,
        },
        {
          path: "/settings-account",
          name: "AccountSettings",
          component: AccountSettings,
        },
        {
          path: "/bug-report",
          name: "BugReport",
          component: BugReport,
        },
        {
          path: "/home/:id",
          name: "PieId",
          component: PieId,
        },
        {
          path: "/admin/:id",
          name: "PieIdForAdmin",
          component: PieIdForAdmin,
        },
        {
          path: "/analytics/:id",
          name: "Analytics",
          component: Analytics,
        },
        {
          path: "/lumpSum/:id",
          name: "lumpSum",
          component: lumpSum,
        },
        {
          path: "/wellLog/:id",
          name: "wellLog",
          component: WellLog,
        },
        {
          path: "/contributions/:id",
          name: "Contributions",
          component: Contributions,
        },
        {
          path: "/contributionsSearch/:id",
          name: "ContributionsSearch",
          component: ContributionsSearch,
        },
        {
          path: "/summary/:id",
          name: "Summary",
          component: Summary,
        },
        {
          path: "/changeLog",
          name: "ChangeLog",
          component: ChangeLog,
        },
      ],
    },

    { path: "*", component: Page404 },
    {
      path: "/home",
      name: "Home",
      component: Home,
    },
    {
      path: "/add-pie",
      name: "AddPie",
      component: AddPie,
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/signup",
      name: "SignUp",
      component: SignUp,
    },
    {
      path: "/reset-password",
      name: "ResetPass",
      component: ResetPass,
    },
  ],
});
